<template>
  <AddAdvertising />
</template>
<script>
import appConfig from '@/app.config'
import AddAdvertising from '../../../components/dadban/advertising/AddAdvertising.vue'
export default {
  page: {
    title: 'اضافه کردن فرصت شغلی',
    meta: [
      {
        name: 'description',
        content: appConfig.description,
      },
    ],
  },
  name: 'dadban-add-advertisings',
  components: {
    AddAdvertising,
  },
}
</script>
